
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["runSmoothingForVertices"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "834d57039a258da2.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "834d57039a258da2.worker.js");
					addMethods(w, methods)
					
					return w
				}
			